import React from 'react';
import PropTypes from 'prop-types';
import { isIE } from 'react-device-detect';

const Main = ({ className, children, keygen }) => {
  const Tag = isIE ? 'div' : 'main';
  return children ? (
    <Tag className={className || null} key={keygen || null}>
      {children}
    </Tag>
  ) : null;
};

export default Main;

Main.propTypes = {
  className: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.element),
  keygen: PropTypes.string,
};

Main.defaultProps = {
  className: null,
  children: null,
  keygen: null,
};
